// extracted by mini-css-extract-plugin
export var avatarContainer = "_7h-0";
export var avatarTypingWave = "_7h-i";
export var gray = "_7h-f";
export var green = "_7h-c";
export var icon = "_7h-9";
export var image = "_7h-1";
export var lg = "_7h-6";
export var md = "_7h-5";
export var presenceDot = "_7h-b";
export var red = "_7h-d";
export var sm = "_7h-4";
export var status = "_7h-a";
export var typingDot = "_7h-h";
export var typingPill = "_7h-g";
export var xl = "_7h-7";
export var xs = "_7h-3";
export var xxl = "_7h-8";
export var xxs = "_7h-2";
export var yellow = "_7h-e";